import {FinanceAPI} from "@/api/FinanceAPI";
// import halyk from "@/store/payment-api";

export const financeModule = {
    state: () => ({
        finance: {},
        operation_id: '',
        replenishment_id: ''
    }),
    getters: {
        finance: state => state.finance,
    },
    mutations: {
        setFinance(state, data) {
            state.finance = data
        },
        setOperationId(state, data) {
            state.operation_id = data
        },
        setReplenishmentId(state, data) {
            state.replenishment_id = data
        }
    },
    actions: {
        async getFinance({commit, rootState}) {
            return await FinanceAPI.getFinance(rootState.authorization.userId)
                .then(res => {
                    commit("setFinance", res.data)
                    return res.status;
                })
                .catch((error) => {
                    let errorStatus = error.response.status

                    if (String(errorStatus).startsWith('4')){
                      commit('clientError', null, { root: true })
                    }else if(String(errorStatus).startsWith('5')){
                      commit('serverError', null, { root: true })
                    }

                    return errorStatus;
                });
        },
        async downloadFinance({rootState}) {
            return await FinanceAPI.downloadFinance(rootState.authorization.userId, rootState.assistant.language)
                .then((res) => {
                    return res
                })
                .catch((error) => {
                    let errorStatus = error.response.status

                    if (String(errorStatus).startsWith('4')){
                      commit('clientError', null, { root: true })
                    }else if(String(errorStatus).startsWith('5')){
                      commit('serverError', null, { root: true })
                    }

                    return errorStatus;
                });
        },
        async payment({}, payData) {
            console.log("2", payData.invoiceID)
            const formData = new FormData();
            formData.append("grant_type", "client_credentials");
            formData.append("scope", "webapi usermanagement email_send verification statement statistics payment");
            formData.append("client_id", "test");
            formData.append("client_secret", "yF587AV9Ms94qN2QShFzVR3vFnWkhjbAK3sG");
            formData.append("invoiceID", payData.invoiceID);
            formData.append("amount", payData.sum);
            formData.append("currency", "KZT");
            formData.append("terminal", "67e34d63-102f-4bd1-898e-370781d0074d");

            return await FinanceAPI.paymentService(formData)
                .then(res => {
                    return res.data
                })
                .catch((error) => {
                    return error;
                });
        },

        async authWooppay({}, authData) {              
            return await FinanceAPI.wooppayAuth(authData)
                .then(res => {
                    return res.data
                })
                .catch((error) => {
                    return error;
                });
        },
        async authWooppayB({}, authData) {              
            return await FinanceAPI.wooppayAuthB(authData)
                .then(res => {
                    return res.data
                })
                .catch((error) => {
                    return error;
                });
        },
        async paymentWooppay({commit}, payData) {         
            return await FinanceAPI.wooppayPay(payData)
                .then(res => {
                    // commit("setOperationId", res.data.data.attributes.operation_id)
                    localStorage.setItem('payType', 'card')
                    return res.data
                })
                .catch((error) => {
                    return error;
                });
        },
        async paymentWooppayBalance({commit}, payData) {    
            return await FinanceAPI.wooppayPayBalance(payData)
                .then(res => {
                    commit("setOperationId", res.data.response.operation_id)
                    commit("setReplenishmentId", res.data.response.replenishment_id)
                    localStorage.setItem('payType', 'balance')
                    return res.data
                })
                .catch((error) => {
                    return error;
                });
        },
        async getWooppayCard({}, payData) {         
            return await FinanceAPI.getWooppayCard(payData)
                .then(res => {
                    return res.data
                })
                .catch((error) => {
                    return error;
                });
        },
        async payWithCard({}, data) {         
            return await FinanceAPI.payWithCard(data)
                .then(res => {
                    return res.data
                })
                .catch((error) => {
                    return error;
                });
        },
        async deleteCard({}, data) {         
            return await FinanceAPI.deleteCard(data)
                .then(res => {
                    return res.status
                })
                .catch((error) => {
                    return error;
                });
        },
        async getReceiptPDF({state}, data) {    
            return await FinanceAPI.getReceipt(data)
                .then(res => {
                    return res
                })
                .catch((error) => {
                    return error.response;
                });
        },
        async getBalanceReceiptPDF({state}, data) {    
            return await FinanceAPI.getReceipt(data)
                .then(res => {
                    return res
                })
                .catch((error) => {
                    return error.response;
                });
        },
        async getOperationData({state}, data) {  
            return await FinanceAPI.getOperationData(data)
                .then(res => {
                    return res.data
                })
                .catch((error) => {
                    return error.response;
                });
        },
        async getBalanceOperationData({state}, data) {    
            data.payData.operation_ids = [state.operation_id]
            return await FinanceAPI.getBalanceOperationData(data)
                .then(res => {
                    return res.data
                })
                .catch((error) => {
                    return error.response;
                });
        },
        async payWoopBalance({state}, data) {    
            data.balanceData.operation_id = state.replenishment_id
            return await FinanceAPI.payBalance(data)
                .then(res => {
                    return res.data
                })
                .catch((error) => {
                    return error;
                });
        },
    },
    namespaced: true
}